import type { DatePickerProps } from '@pijma/hero-types'

import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'

export * from './CSSValue'

export const isContainerQueriesSupported =
  typeof document !== 'undefined'
    ? 'container' in document.documentElement.style
    : false

type shadowToken = {
  x: string
  y: string
  blur: string
  spread: string
  color: string
  type: string
}
export const shadowTokenToString = (s: shadowToken) => {
  return [s.x, s.y, s.blur, s.spread, s.color].join(' ')
}
export const animationTokenToString = (s: string) => {
  const props = s.split(' ')
  props[0] = props[0] + 'ms'
  return props.join(' ')
}

export function debounce<F extends (...args: Parameters<F>) => ReturnType<F>>(
  func: F,
  waitFor: number,
): (...args: Parameters<F>) => void {
  let timeout: ReturnType<typeof setTimeout>
  return (...args: Parameters<F>): void => {
    clearTimeout(timeout)
    timeout = setTimeout(() => func(...args), waitFor)
  }
}

type TTypography = {
  fontWeight?: string | number
  fontFamily?: string
  fontSize?: number | string
  lineHeight?: number | string
}
export const changeTokenTypography = (value: TTypography) => {
  const newValue = value
  if (newValue.fontWeight) {
    newValue.fontWeight =
      newValue.fontWeight === 'Regular' ? 400 : newValue.fontWeight
  }
  if (newValue.fontFamily) {
    newValue.fontFamily =
      newValue.fontFamily === "Suisse Int'l"
        ? 'Sussie Intl'
        : newValue.fontFamily
  }
  if (newValue.fontSize) {
    newValue.fontSize = Number.isNaN(Number(newValue.fontSize))
      ? newValue.fontSize
      : `${newValue.fontSize}px`
  }
  if (newValue.lineHeight) {
    newValue.lineHeight = Number.isNaN(Number(newValue.lineHeight))
      ? newValue.lineHeight
      : `${newValue.lineHeight}px`
  }
  return newValue
}

type TBorder = {
  color?: string
  width?: string | number
  style?: string
}

export const changeTokenBorder = (value: TBorder) => {
  const { color, width, style } = value

  const arr = []
  if (width) {
    const newWidht = Number.isNaN(Number(width)) ? width : `${width}px`
    arr.push(newWidht)
  }
  if (style) {
    arr.push(style)
  }
  if (color) {
    arr.push(color)
  }
  return arr.join(' ')
}

export const toISODate = (date?: Dayjs) => date?.format('YYYY-MM-DD')
export const isDateTimePickerValueValid = (
  value?: DatePickerProps['value'],
) => {
  if (Array.isArray(value)) return value.every((date) => dayjs(date).isValid())
  return dayjs(value).isValid()
}

export const isEqual = (a: unknown, b: unknown) =>
  JSON.stringify(a) === JSON.stringify(b)
